import request from "@/utils/request";
const qs = require("qs");
import { MLMReport } from "@/utils/requestApi";

// progresss

export function listMedicine(data) {
  return request({
    url: MLMReport() + "/medicine_master/list",
    method: "POST",
    data: qs.stringify(data)
  });
}



// WEBPACK FOOTER //
// ./src/api/listMedicine.js